import { pickBy } from 'lodash';
import { useLocalStorage } from 'usehooks-ts';

import { Json, Literal } from '../types';

export const SETTINGS_ALLOWED_KEYS = ['tip.modelKinds.disabledAt'] as const;
const SETTINGS_ALLOWED_PREFIXES = ['conversation.chat.settings'];

export const useLocalSetting = <T extends Literal | Json>(key: string | null, defaultValue: T) => {
  const [settings, setSettings] = useLocalStorage<{ [key: string]: Literal | Json }>(
    'localSettings',
    {},
  );

  if (key === null) {
    return [defaultValue, () => {}] as const;
  }

  const value = settings[key] ?? defaultValue;
  const setValue = (newValue: T) => {
    setSettings((prev) =>
      pickBy(
        { ...prev, [key]: newValue },
        (_, key) =>
          SETTINGS_ALLOWED_KEYS.includes(key as any) ||
          SETTINGS_ALLOWED_PREFIXES.some((prefix) => key.startsWith(prefix)),
      ),
    );
  };

  return [value as T, setValue] as const;
};
